import { qrcodeShortToLong } from '@/api/notify';
import {
  promoteRelationshipBindPromoter,
  promoteRelationshipGetMyPromoter,
} from '@/api/marketing';
import utils from '@/utils/common';
import store from '@/vuex/index';
import eventReporter from '@/utils/event-reporter';
const TAG = 'PromoterHandle.js';
import { setQuery } from '@/utils';

class PromoteHandle {
  constructor(query) {
    if (query) {
      this.query = query;
    }
  }

  /**
   * 1，初始化参数
   * 2，获取活动ID页面ID,
   * 3，保存推广员参数
  */
  async initQuery() {
    const { id = '', promoter = '', pageId = '', source = '', recommend = '', type = '' } = this.query;
    let { scene = '' } = this.query;
    this.type = type;
    this.activityId = id;
    this.promoter = promoter;
    this.pageId = pageId;
    this.source = source;
    this.recommend = recommend;
    const that = this;
    if (scene) { // 如果有scene参数说明是扫推广码进来
      console.log(TAG, '解析扫码推广员信息scene：', scene);
      scene = decodeURIComponent(scene);
      if (!scene) {
        return {};
      }
      this.activityId = utils.getQueryVariable(scene, 'id');
      let shortParam = '';
      if (scene.startsWith('promote')) shortParam = scene.substring('promote'.length, scene.length);// 扫推广二维码途径
      if (scene.startsWith('short')) shortParam = scene.substring(5, scene.length); // 海报分享途径
      if (that.checkNum(scene)) shortParam = scene; // 海报纯数字参数分享途径
      if (shortParam) {
        const result = await qrcodeShortToLong(shortParam);
        if (result.success) {
          const longParam = result.data;
          console.log('longParam', longParam);
          this.longParam = longParam;
          that.pageId = that.activityId = utils.getQueryVariableByComma(longParam, 'id');
          if (scene.startsWith('short')) {
            that.pageId = utils.getQueryVariableByComma(longParam, 'goodsid'); // 海报分享途径
            that.recommend = utils.getQueryVariableByComma(longParam, 'recommend');
          }
          if (scene.startsWith('promote')) {
            that.promoter = utils.getQueryVariableByComma(longParam, 'promoter');
          }
        }
      }
    }
    eventReporter.insertCustomProperties({
      activity_id: that.activityId || '',
      promoterId: that.promoter || '',
    }); // 神策自定义属性上报---活动id及推广员id属性上报
    if (this.promoter) { // 如果是从推广链接进来
      console.log(TAG, '推广链接发现推广员参数：', that.promoter);
      if (that.isEmptyPromoter()) {
        console.log('vuex数据为空');
        let eventType = 'STORE_PROMOTER';
        if (that.source === 'qy') { // 来源于企业微信
          eventType = 'STORE_QY_PROMOTER';
          store.commit('$uStore', { name: 'promoterQiYe', value: that.promoter });
        }
        const pageUrl = this.getCurrentPageUrl(this.longParam);
        if (pageUrl) {
          store.commit('$uStore', { name: 'promoterUrl', value: pageUrl });
        }
        if (type) {
          store.commit('$uStore', { name: 'relationshipType', value: type });
        }
        store.commit('$uStore', { name: 'promoter', value: that.promoter });
        store.commit('$uStore', { name: 'promoterExpireTime', value: Date.now() + 86400000 });
        // 埋点 start
        const reportData = {
          promoter: that.promoter,
          eventType,
          promoterExpireTime: store.state.promoterExpireTime || '',
        };
        eventReporter.trackPromoterEvent(reportData);
        // 埋点 end
      }
    }
    return {
      activityId: that.activityId,
      promoter: that.promoter,
      pageId: that.pageId,
      source: that.source,
      recommend: that.recommend,
      type: that.type,
    };
  }

  async onloadBindPromoter() {
    try {
      const { promoter = '', type = '' } = await this.initQuery();
      if (promoter) {
        // 埋点 start
        if (!store.getters.isLogin) {
          const reportData = { promoter: promoter, eventType: 'lOGIN_INIT' };
          eventReporter.trackPromoterEvent(reportData);
          // 此处可加埋点事件
          console.log('未登录，暂不绑定');
          return;
        };
        const reportData = { promoter: promoter, eventType: 'ONLOAD_BINDING' };
        eventReporter.trackPromoterEvent(reportData);
        // 埋点 end
        const pageUrl = this.getCurrentPageUrl(this.longParam);
        this.bindPromoter(promoter, pageUrl, type);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async bindPromoter(promoter, pageUrl, type) {
    try {
      const result = await promoteRelationshipGetMyPromoter();
      if (result.success && result.data) {
        const { status, staffId } = result.data;
        if (status === '0' && staffId === promoter) {
          console.log(TAG, 'doBingding() 解绑数据和本地数据一致，不需要绑定 staffId:' + staffId);
          cleanPromoterInfo();
          // 埋点 start
          const reportData = { promoter: promoter, eventType: 'COMMAND_UNBINDING', promoterDesc: '解绑' };
          eventReporter.trackPromoterEvent(reportData);
          // 埋点 end
          return;
        }
      }
    } catch (error) {
      console.log(TAG, error);
    }
    try {
      const bindResult = await promoteRelationshipBindPromoter(promoter, pageUrl, type);
      if (bindResult.success && bindResult.data) {
        const { staffId, invalidTime } = bindResult.data;
        if (staffId) {
          console.log(TAG, '服务器返回,绑定关系成功 staffId:' + staffId);
          store.commit('$uStore', { name: 'promoter', value: staffId });
          store.commit('$uStore', { name: 'promoterExpireTime', value: invalidTime });
          // 埋点 start
          const reportData = {
            promoter: staffId,
            eventType: 'BINDING_SUCCESS',
            promoterExpireTime: invalidTime,
            promoterDesc: '服务器绑定成功',
          };
          eventReporter.trackPromoterEvent(reportData);
          // 埋点 end
        }
      } else {
        const reportData = {
          promoter: promoter,
          eventType: 'BINDING_FAIL',
          promoterDesc: '绑定失败',
        };
        eventReporter.trackPromoterEvent(reportData);
        console.log(TAG, 'doBingding() 服务器返回绑定失败:' + promoter);
      }
    } catch (error) {
      console.log(TAG, error);
    }
  }

  /**
   * 格式化推广员链接path
  */
  transformPromoterPath(path) {
    if (!path) {
      return path;
    }
    // 埋点 start
    const reportData = {};
    // 埋点 end
    // 读取vuex promoter ID
    let promoter;
    if (store.state.promoterQiYe) {
      promoter = store.state.promoterQiYe;
      console.log(TAG, 'vuex 有企业微信 promoter，优先企业promoter:' + promoter);
      reportData.eventType = 'SHARE_QIYE';
    } else {
      promoter = store.state.promoter;
      console.log(TAG, 'vuex 读取正常 promoter:' + promoter);
      reportData.eventType = 'SHARE_NORMAL';
    }
    reportData.promoter = promoter;
    // 分享链接如果没有promoter就强制加上
    if (!!promoter && !!path && !path.includes('promoter=')) {
      if (path.indexOf('?') !== -1) {
        path += `&promoter=${promoter}`;
      } else {
        path += `?promoter=${promoter}`;
      }
    }
    reportData.sharePath = path;
    eventReporter.trackPromoterEvent(reportData);
    console.log(TAG, 'transformPromoterPath:', path);
    return path;
  }

  getAppPromoter() { // 获取本地推广员参数
    // 读取vuex promoter ID
    let promoter;
    if (store.state.promoterQiYe) {
      promoter = store.state.promoterQiYe;
      console.log(TAG, 'vuex 有企业微信 promoter，优先企业promoter:' + promoter);
    } else {
      promoter = store.state.promoter;
      console.log(TAG, 'vuex 读取正常 promoter:' + promoter);
    }
    console.log(TAG, 'getAppPromoter() path:', promoter);
    return promoter || this.promoter;
  }

  getCurrentPageUrl(params) {
    const currentPages = getCurrentPages();
    const currentPage = currentPages[currentPages.length - 1];
    const { route: path, options } = currentPage;
    let pageUrl = `${path}?${decodeURIComponent(setQuery(options))}`;
    if (params) {
      pageUrl = `${path}?scene=${params}`;
    }
    return pageUrl;
  }

  isEmptyPromoter() { // 判断本地推广员信息是否为空
    console.log('store.state.promoter', store.state.promoter);
    return (!store.state.promoter || store.state.promoterExpireTime < Date.now());
  }

  checkNum(num) {
    return !!num && /^[0-9]*$/.test(num);
  }
}

function cleanPromoterInfo() {
  // 绑定关系状态 0-已解绑 1-有效
  store.commit('$uStore', { name: 'promoter', value: '' });
  store.commit('$uStore', { name: 'promoterExpireTime', value: '' });
  console.log(TAG, 'cleanPromoterInfo() 清理本地推广员信息');
}
/**
   * 获取用户绑定信息
  */
 export const getMyPromoter = async() => {
  try {
    const res = promoteRelationshipGetMyPromoter();
    if (res.success && res.data) {
      const { staffId, invalidTime, status } = res.data;
      if (status === '0' && staffId === store.state.promoter) {
        // 绑定关系状态 0-已解绑 1-有效
        console.log(TAG, 'getMyPromoter() 存在解除数据 staffId:' + staffId);
        cleanPromoterInfo();
        // 埋点 start
        const reportData = {
          promoter: staffId,
          eventType: 'CMD_UNBINDING',
        };
        eventReporter.trackPromoterEvent(reportData);
        // 埋点 end
        return;
      }
      if (staffId) {
        console.log(TAG, 'getMyPromoter() 从服务器读取到 staffId:' + staffId);
        store.commit('$uStore', { name: 'promoter', value: staffId });
        store.commit('$uStore', { name: 'promoterExpireTime', value: invalidTime });
        // 埋点 start
        const reportData = {
          promoter: staffId,
          eventType: 'STORE_UPDATE',
          promoterExpireTime: invalidTime,
          promoterDesc: '更新绑定数据',
        };
        eventReporter.trackPromoterEvent(reportData);
        // 埋点 end
      }
    }
  } catch (error) {
    console.log(error);
  }
};
export default PromoteHandle;
